var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"authorizationWrapper"},[_c('topheader',{attrs:{"back":"/signin"}}),_c('div',{staticClass:"brandWrapper"},[_c('logotype',{attrs:{"big":true}})],1),_c('authorization')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }